import TriggeredByFlows from "components/TriggeredByFlows";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { isFlowsTrigger } from "utils/flows";
import { StackTaskRun } from "views/Stack/Tasks/gql";

const StackTasksTableTriggeredByCell = ({
  item: task,
  ...cellProps
}: TableSimpleCellProps<StackTaskRun>) => {
  const triggeredBy = task.triggeredBy || "";
  const isFlows = isFlowsTrigger(triggeredBy);

  return (
    <TableSimpleCell {...cellProps}>
      {isFlows && <TriggeredByFlows triggeredBy={triggeredBy} />}
      {!isFlows && <TableCellText>{triggeredBy}</TableCellText>}
    </TableSimpleCell>
  );
};

export default StackTasksTableTriggeredByCell;
